import React, {useMemo} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

// eslint-disable-next-line no-unused-vars
const ReactHookTableWrapper = ({columns, data, bulk = {}}) => {
  const RenderRows = useMemo(() => {
    const preparedRows = data.map((row, rowIndex) => {
      const rowClass = _.get(row, 'rowClass', 'row');
      return (
        // eslint-disable-next-line react/no-array-index-key
        <tr key={_.get(row, 'id', `row-${rowIndex}`)} className={rowClass}>
          {columns.map(column => (
            <td key={column.accessor}>{row[column.accessor]}</td>
          ))}
        </tr>
      );
    });
    return preparedRows;
  }, [columns, data]);

  const RenderHeaders = useMemo(
    () =>
      columns.map(column => (
        <th key={column.accessor}>{column.Header}</th>
      )),
    [columns],
  );

  // Render the UI for your table
  return (
    <table className="table">
      <thead>
        <tr>{RenderHeaders}</tr>
      </thead>

      <tbody>{RenderRows}</tbody>
    </table>
  );
};
ReactHookTableWrapper.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  columns: PropTypes.instanceOf(Object).isRequired,
  bulk: PropTypes.instanceOf(Object),
};

export default ReactHookTableWrapper;
